// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadBlock_container__1fPNF","image":"DownloadBlock_image__1pRJO"};